// extracted by mini-css-extract-plugin
export var lg = "_4r-4";
export var md = "_4r-3";
export var sm = "_4r-2";
export var xs = "_4r-1";
export var xxs = "_4r-0";